// Returns a friendly 1/2 letter heading for a given heading angle
// showVerbose returns a longer version with heading in parentheses
export const getFriendlyHeading = (heading, showVerbose) => {
    if (!heading) return null;

    heading = parseInt(heading);

    var directions = showVerbose
        ? ['North', 'North-East', 'East', 'South-East', 'South', 'South-West', 'West', 'North-West']
        : ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];
    var index = Math.round(((heading %= 360) < 0 ? heading + 360 : heading) / 45) % 8;

    return directions[index] + (showVerbose ? ' (' + heading + ')' : '');
};

export const rounding = (value) => {
    if (!value && value !== 0) return null;
    return value.toFixed(2);
};
